import { useState, useEffect } from "react";
import { Observable } from "rxjs";

export function useHookSubscribe<T>(initValue: T, stream: Observable<T>) {
  const [value, setValue] = useState<T>(initValue);
  useEffect(() => {
    const subscr = stream.subscribe(val => { setValue(val); });
    return () => subscr.unsubscribe();
  }, [stream, setValue]);
  return value;
}
